<template>
  <div>
    <b-button
      v-b-modal.modal-create-impugned-tracker
      variant="outline-primary"
      @click="initialSetup"
    >
      Create New
    </b-button>

    <b-modal
      id="modal-create-impugned-tracker"
      title="Create New Impugned Tracker"
      no-close-on-backdrop
      centered
      ok-title="submit"
      cancel-variant="outline-secondary"
    >
      <b-card-text>
        <b-overlay
          :show="$store.state.impugnedTrackerStore.isNewImpugnedLoading"
          rounded="sm"
          variant="transparent"
          opacity="0.5"
          blur="2px"
        >
          <validation-observer
            ref="impugnedForm"
            #default="{ invalid }"
          >
            <b-form @submit.prevent="findImpugned">
              <!-- Select District -->
              <validation-provider
                #default="{ errors }"
                name="District"
                vid="district"
                rules="required"
              >
                <b-form-group
                  label="Select District"
                  label-for="district"
                >
                  <v-select
                    v-model="DistrictSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="DistrictOptions"
                    label="name"
                    placeholder="Select District"
                    @input="onDistrictSelect"
                  />
                </b-form-group>
              </validation-provider>

              <!-- Select Order Date -->
              <validation-provider
                #default="{ errors }"
                name="Order Date"
                vid="order-date"
                rules="required"
              >
                <b-form-group
                  label="Select Order Date"
                  label-for="order-date"
                >
                  <b-form-datepicker
                    id="order-date"
                    v-model="OrderDate"
                    :max="maxDate"
                    locale="en-GB"
                    :date-format-options="{
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    }"
                  />
                </b-form-group>
              </validation-provider>
            </b-form>
          </validation-observer>
          <template #overlay>
            <div class="text-center">
              <b-spinner variant="secondary" />
              <p id="cancel-label">
                {{ loadingMsg }}
              </p>
            </div>
          </template>
        </b-overlay>
      </b-card-text>

      <!-- Footer -->
      <template #modal-footer>
        <div class="w-100">
          <div>
            <div>
              <b-button
                variant="primary"
                class="float-right"
                type="submit1"
                :disabled="$store.state.impugnedTrackerStore.isNewImpugnedLoading"
                @click="findImpugned"
              >
                Submit
              </b-button>
            </div>
            <div>
              <b-button
                variant="outline-dark"
                class="float-right mr-1 ml-1"
                type="cancel"
                @click="$bvModal.hide('modal-create-impugned-tracker')"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BCardText,
  BFormGroup,
  BOverlay,
  BSpinner,
  BFormInvalidFeedback,
  BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import moment from 'moment'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BCardText,
    BFormInvalidFeedback,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BSpinner,
    BFormDatepicker,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: ['refreshList'],
  data() {
    return {
      DistrictOptions: [],
      DistrictSelected: null,
      OrderDate: null,
      loadingMsg: '',

      // validation rules
      required,
    }
  },
  computed: {
    maxDate() {
      return new Date().toISOString().split('T')[0]
    },
    formattedOrderDate() {
      if (!this.OrderDate) return ''

      return moment(this.OrderDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
  },
  beforeMount() {
    this.getDistricts()
  },
  methods: {
    getDistricts() {
      this.$store
        .dispatch('impugnedTrackerStore/fetchImpugnedDistrict')
        .then(response => {
          console.log('Districts --> ', response)
          if (response) {
            this.DistrictOptions = response.districts || response.data || []
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    initialSetup() {
      this.DistrictSelected = null
      this.OrderDate = null
    },
    onDistrictSelect(event) {
      console.log(event)
    },
    findImpugned() {
      this.loadingMsg = 'Please Wait, Searching for Impugned Order!'
      event.preventDefault()
      this.$refs.impugnedForm.validate().then(success => {
        if (success) {
          const data = {
            district: String(this.DistrictSelected.name),
            order_date: this.formattedOrderDate,
          }
          console.log('Data C', data)
          store
            .dispatch('impugnedTrackerStore/findImpugned', {
              ctx: this,
              payload: data,
            })
            .then(response => {
              console.log({ Impugned: response })
              if (response != null) {
                if (response.success) {
                  this.refreshList()
                }
              }
            })
        }
      })
    },
  },
  setup(props, context) {
    const { refFormObserver, getValidationState, resetForm } = formValidation()

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
